import React from "react";
import { JobsViewProps } from "./JobsView.types";
import { LargeScreenView } from "./LargeScreenView";
import { SmallScreenView } from "./SmallScreenView";
import { Platform } from "react-native";
import { useResponsive } from "@clearabee/ui-library-native";

export const JobsView = (props: JobsViewProps): React.ReactElement => {
  const { screens } = useResponsive();
  if (Platform.OS === "web" && screens.medium) {
    return <LargeScreenView {...props} />;
  }

  return <SmallScreenView {...props} />;
};
